import React from "react";
import SurveyPreview from "./SurveyPreview";
import VoiceSurveyPreview from "../../pages/Survey/voice/VoiceSurveyPreview";

function SurveyPreviewSection({ steps, settings, title }) {
  // A Modern assessment previews as its respondents will take it.
  if (settings?.respondMode === "voice") {
    return <VoiceSurveyPreview steps={steps} settings={settings} title={title} />;
  }
  return (
    <SurveyPreview
      steps={steps}
      settings={settings}
      title={title}
      mode="preview"
    />
  );
}

export default SurveyPreviewSection;
